import { z } from "zod";

/** `system.about` — static build / version metadata for Settings → About. */
export const aboutInput = z.object({});

export const aboutOutput = z.object({
  version: z.string(),
  gitSha: z.string(),
  builtAt: z.string().nullable(),
  environment: z.string(),
  runtime: z.string(),
});

const healthStatus = z.enum(["ok", "degraded", "down"]);

/** `system.health` — live per-service status grid. */
export const healthInput = z.object({});

export const healthOutput = z.array(
  z.object({
    key: z.string(),
    label: z.string(),
    status: healthStatus,
    latencyMs: z.number().optional(),
    detail: z.string().optional(),
  }),
);
